import script from "./UserTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=6b1fd408&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1fd408"]])

export default __exports__